export default __webpack_public_path__ + "static/media/rocket_anim_51.860a841c.png";